// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidateEmail_container__3VrNt","logo":"ValidateEmail_logo__2E3yp"};